const ADMIN_USER = 'fulcrum/container/Admin/User/User'
const MOUNT = 'fulcrum/container/Admin/User/User/MOUNT'
const UNMOUNT = 'fulcrum/container/Admin/User/User/UNMOUNT'
const UPDATE_ACTIVE_DIALOG = 'fulcrum/container/Admin/User/User/UPDATE_ACTIVE_DIALOG'

export {
  ADMIN_USER,
  MOUNT,
  UNMOUNT,
  UPDATE_ACTIVE_DIALOG,
}
